export default __webpack_public_path__ + "static/media/glueple.b00df335.png";